module.exports = __webpack_public_path__ + "static/img/iapp_en@2x.ea23da6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/connect/iapp_en@2x.png
// module id = 442
// module chunks = 0